import { Component, OnInit } from '@angular/core';
import { LeaveService } from 'src/app/shared/services/leaveservices/leave.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';

import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-leaves-status',
  templateUrl: './leaves-status.component.html',
  styleUrls: ['./leaves-status.component.css'],
  standalone: true,
  imports: [RouterModule, BsDatepickerModule],
})
export class LeavesStatusComponent implements OnInit {
  bsInlineValue = new Date();
  bsInlineRangeValue: Date[];
  maxDate = new Date();
  public absent: any = '';
  public stats: any = [];
  public data: any = [];
  public user: any = [];
  constructor(
    private route: ActivatedRoute,
    private _leaveService: LeaveService
  ) {
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.maxDate.setDate(this.maxDate.getDate() + 7);
    this.getLeaveStats();
    this.bsInlineRangeValue = [this.bsInlineValue, this.maxDate];
  }

  getLeaveStats() {
    this._leaveService.getStatsFilter().then((value) => {
      // alert("here");
      this.absent = value.data.absents;
      this.stats = value.data.leaves;
    });
  }
  getData(data: any) {
    const temp = JSON.parse(data);
    this.data = temp;

  }
  ngOnInit(): void {
    this.getData(this.route.snapshot.queryParams.data);
  }

  getLeaveColor(data: any) {
    if (data == 'pending') {
      return '#478AD1';
    }
    if (data == 'rejected') {
      return '#FD7171';
    }
    if (data == 'approved') {
      return '#71D875';
    }
    return '';
  }
}
